import SuccessModal from "./SuccessModal";

export default SuccessModal;